import { html, nothing } from 'omni-ui';
import { Om2FormFieldBase, SHARED_FIELD } from './common/base.js';
import { Om2ImageUpload } from '../om2-image-upload.js';

Om2ImageUpload.register();

/**
 * Render an image input
 */
export class Om2FormFieldImage extends Om2FormFieldBase {
  static metadata = {
    config: {
      label: 'Image Input',
      fields: {
        id: SHARED_FIELD,
        title: SHARED_FIELD,
        tooltip: SHARED_FIELD,
        circleDesign: {
          title: 'Circle/New Design',
          type: 'boolean',
        },
        class: SHARED_FIELD,
        required: SHARED_FIELD,
        disabled: SHARED_FIELD,
        readonly: {
          title: 'Read Only',
          type: 'boolean',
          tooltip:
            "Rendered as disabled since the image component can't be readonly",
        },
      },
    },
  };

  render() {
    const { schema } = this;
    return html`
      <om2-image-upload
        .name=${this.key}
        .value=${this.data}
        .env=${this.env}
        maxSize=${schema.maxSize ?? nothing}
        ?circledesign=${schema.circleDesign}
        ?required=${schema.required}
        ?disabled=${schema.disabled ||
        schema.readonly ||
        this.context?.readonly ||
        this._isHidden()}
        @input=${e => e.stopPropagation()}
        @change=${e => {
          this.dispatchEvent(
            new CustomEvent('input', {
              detail: {
                name: this.key,
                value: e.detail.value,
              },
              bubbles: true,
            })
          );
        }}
      >
      </om2-image-upload>
    `;
  }
}

Om2FormFieldImage.register('image');
